import moment, { LocaleSpecification, Moment } from 'moment-timezone'
import 'moment-business-time'
import { IBusinessTime, ILocationSchedule } from '../stores/LocationStore'

export const DCLSchedule: ILocationSchedule = {
  reference: 'DCL',
  'monday': [
    {
      'end': '17:00:00',
      'start': '09:00:00'
    }
  ],
  'tuesday': [
    {
      'end': '17:00:00',
      'start': '09:00:00'
    }
  ],
  'wednesday': [
    {
      'end': '17:00:00',
      'start': '09:00:00'
    }
  ],
  'thursday': [
    {
      'end': '17:00:00',
      'start': '09:00:00'
    }
  ],
  'friday': [
    {
      'end': '17:00:00',
      'start': '09:00:00'
    }
  ],
  'saturday': [
    {
      'end': '12:00:00',
      'start': '09:00:00'
    }
  ],
  'sunday': [],
  'holidays': []
}

export const NoSchedule: ILocationSchedule = {
  reference: 'ALL',

  'monday': [

  ],
  'tuesday': [

  ],
  'wednesday': [
  ],
  'thursday': [

  ],
  'friday': [

  ],
  'saturday': [

  ],
  'sunday': [

  ],
  'holidays': []
}

export const AllSchedule: ILocationSchedule = {
  reference: 'ALL',

  'monday': [
    {
      'end': '23:59:59',
      'start': '00:00:00'
    }
  ],
  'tuesday': [
    {
      'end': '23:59:59',
      'start': '00:00:00'
    }
  ],
  'wednesday': [
    {
      'end': '23:59:59',
      'start': '00:00:00'
    }
  ],
  'thursday': [
    {
      'end': '23:59:59',
      'start': '00:00:00'
    }
  ],
  'friday': [
    {
      'end': '23:59:59',
      'start': '00:00:00'
    }
  ],
  'saturday': [
    {
      'end': '23:59:59',
      'start': '00:00:00'
    }
  ],
  'sunday': [
    {
      'end': '23:59:59',
      'start': '00:00:00'
    }
  ],
  'holidays': []
}

export const getWeekOffFrom = (schedule: ILocationSchedule, isIso = true) => {
  const isoDays = []

  if (schedule.monday?.length === 0) isoDays.push(1)

  if (schedule.tuesday?.length === 0) isoDays.push(2)

  if (schedule.wednesday?.length === 0) isoDays.push(3)

  if (schedule.thursday?.length === 0) isoDays.push(4)

  if (schedule.friday?.length === 0) isoDays.push(5)

  if (schedule.saturday?.length === 0) isoDays.push(6)

  if (schedule.sunday?.length === 0) isoDays.push(7)

  if (!isIso) {
    if (schedule.sunday?.length === 0) isoDays.push(0)
  }

  return isoDays
}

export const getDayScheduleFor = (date: Moment, schedule: ILocationSchedule ) => {
  const isoDay = date.isoWeekday()

  if (isoDay === 1) { return schedule.monday || [] }

  if (isoDay === 2) { return schedule.tuesday || [] }

  if (isoDay === 3) { return schedule.wednesday || [] }

  if (isoDay === 4) { return schedule.thursday || [] }

  if (isoDay === 5) { return schedule.friday || [] }

  if (isoDay === 6) { return schedule.saturday || [] }

  if (isoDay === 7) { return schedule.sunday || [] }

  return []
}

export interface ITimeOption {
  label: string
  id: string
  value: string
  available: boolean
  minutes: number
  hours: number
}

export const generateTimeOptions = ( scheduleUnit: number, businessTimes: IBusinessTime[] ): ITimeOption[] => {
  const timeOptions :ITimeOption[] = []

  const timeOfDay = moment().startOf('day').hour(0).minute(0).second(0)
  const nextDay = moment().startOf('day').hour(23).minute(0).second(0)
  while (timeOfDay.isSameOrBefore(nextDay)) {
    timeOptions.push({
      label: timeOfDay.format('LT'),
      id: timeOfDay.format('HH:mm'),
      value: timeOfDay.format('HH:mm'),
      available: true,
      minutes: timeOfDay.minute(),
      hours: timeOfDay.hours()
    })
    timeOfDay.add(scheduleUnit, 'minutes')
  }
  const result = businessTimes
    .reduce(((acc, curr, index) => {
      return [
        ...acc,
        ...timeOptions.filter((item) => {
          const value = moment.duration(item.id).asMinutes()
          const startValue = moment.duration(curr.start).asMinutes()
          const endValue = moment.duration(curr.end).asMinutes()

          return value >= startValue && value <= endValue
        })
      ]
    }), [] as ITimeOption[])

  return result
}

export const getMomentWorkingSchedule = (schedule: ILocationSchedule, isIso = true ) => {
  const convertToMoment = (businessTime?: IBusinessTime[] | null) => {
    if (!businessTime || businessTime.length === 0) return null
    const result = []

    for (const business of businessTime) {
      result.push(business.start)
      result.push(business.end)
    }

    return result
  }

  if (isIso) {
    return {
      1: convertToMoment(schedule.monday),
      2: convertToMoment(schedule.tuesday),
      3: convertToMoment(schedule.wednesday),
      4: convertToMoment(schedule.thursday),
      5: convertToMoment(schedule.friday),
      6: convertToMoment(schedule.saturday),
      7: convertToMoment(schedule.sunday)
    }
  } else {
    return {
      1: convertToMoment(schedule.monday),
      2: convertToMoment(schedule.tuesday),
      3: convertToMoment(schedule.wednesday),
      4: convertToMoment(schedule.thursday),
      5: convertToMoment(schedule.friday),
      6: convertToMoment(schedule.saturday),
      0: convertToMoment(schedule.sunday)
    }
  }
}
export const getFirstWorkingDateTime = (date:Moment, schedule: ILocationSchedule, minWorkingHours:number ) => {
  const newLocale: LocaleSpecification = { workinghours: getMomentWorkingSchedule(schedule, false) as any, holidays: (schedule.holidays || []).map(h => (moment(h).format('YYYY-MM-DD'))) }
  moment.updateLocale(moment.locale(), newLocale)
  console.debug('CalendarStore.reaction - update timings - compute insuranceFirstDateTime ', date.format(), newLocale)

  return date.clone().addWorkingTime(minWorkingHours, 'hours')
}

export const getLastWorkingDateTime = (date: Moment, schedule: ILocationSchedule, maxLeadTimeHours: number) => {
  const newLocale: LocaleSpecification = { workinghours: getMomentWorkingSchedule(schedule, false) as any, holidays: (schedule.holidays || []).map(h => (moment(h).format('YYYY-MM-DD'))) }
  moment.updateLocale(moment.locale(), newLocale)
  console.debug('Computing maximum lead time based on schedule: ', date.format(), newLocale)

  return date.clone().addWorkingTime(maxLeadTimeHours, 'hours')
}
